import type { PlayersTabResponse } from '../types';

export const PLAYERS_TAB_MOCK_DATA: PlayersTabResponse = {
  home: {
    goals: [
      {
        name: 'D. Calvert-Lewin',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        goals: 10,
      },
      {
        name: 'L. Nmecha',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/de.svg',
        goals: 6,
      },
      {
        name: 'N. Okafor',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ch.svg',
        goals: 6,
      },
      {
        name: 'B. Aaronson',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/us.svg',
        goals: 4,
      },
      {
        name: 'A. Stach',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/de.svg',
        goals: 4,
      },
      {
        name: 'A. Tanaka',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/jp.svg',
        goals: 2,
      },
      {
        name: 'J. Rodon',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/wal.svg',
        goals: 2,
      },
      {
        name: 'J. Bogle',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        goals: 1,
      },
      {
        name: 'S. Longstaff',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        goals: 1,
      },
      {
        name: 'J. Bijol',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/si.svg',
        goals: 1,
      },
      {
        name: 'E. Ampadu',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/wal.svg',
        goals: 1,
      },
      {
        name: 'J. Justin',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        goals: 1,
      },
    ],
    assists: [
      {
        name: 'B. Aaronson',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/us.svg',
        assists: 4,
      },
      {
        name: 'A. Stach',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/de.svg',
        assists: 3,
      },
      {
        name: 'I. Gruev',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/bg.svg',
        assists: 3,
      },
      {
        name: 'J. Bogle',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        assists: 2,
      },
      {
        name: 'S. Longstaff',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        assists: 2,
      },
      {
        name: 'J. Bijol',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/si.svg',
        assists: 2,
      },
      {
        name: 'D. Calvert-Lewin',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        assists: 1,
      },
      {
        name: 'L. Nmecha',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/de.svg',
        assists: 1,
      },
      {
        name: 'E. Ampadu',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/wal.svg',
        assists: 1,
      },
      {
        name: 'J. Justin',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        assists: 1,
      },
      {
        name: 'G. Wilfried',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/it.svg',
        assists: 1,
      },
      {
        name: 'P. Struijk',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/nl.svg',
        assists: 1,
      },
    ],
    shots: [
      {
        name: 'D. Calvert-Lewin',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        shotsOnTarget: 17,
        shotsOffTarget: 21,
      },
      {
        name: 'B. Aaronson',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/us.svg',
        shotsOnTarget: 9,
        shotsOffTarget: 11,
      },
      {
        name: 'P. Struijk',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/nl.svg',
        shotsOnTarget: 7,
        shotsOffTarget: 10,
      },
      {
        name: 'L. Nmecha',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/de.svg',
        shotsOnTarget: 6,
        shotsOffTarget: 4,
      },
      {
        name: 'A. Stach',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/de.svg',
        shotsOnTarget: 6,
        shotsOffTarget: 9,
      },
      {
        name: 'N. Okafor',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ch.svg',
        shotsOnTarget: 4,
        shotsOffTarget: 6,
      },
      {
        name: 'J. Bijol',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/si.svg',
        shotsOnTarget: 4,
        shotsOffTarget: 4,
      },
      {
        name: 'J. Bogle',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        shotsOnTarget: 3,
        shotsOffTarget: 7,
      },
      {
        name: 'E. Ampadu',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/wal.svg',
        shotsOnTarget: 3,
        shotsOffTarget: 6,
      },
      {
        name: 'J. Justin',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        shotsOnTarget: 3,
        shotsOffTarget: 6,
      },
      {
        name: 'S. Longstaff',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        shotsOnTarget: 2,
        shotsOffTarget: 8,
      },
      {
        name: 'J. Piroe',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/sr.svg',
        shotsOnTarget: 2,
        shotsOffTarget: 3,
      },
      {
        name: 'J. Harrison',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        shotsOnTarget: 2,
        shotsOffTarget: 3,
      },
      {
        name: 'A. Tanaka',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/jp.svg',
        shotsOnTarget: 1,
        shotsOffTarget: 8,
      },
      {
        name: 'J. Rodon',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/wal.svg',
        shotsOnTarget: 1,
        shotsOffTarget: 5,
      },
      {
        name: 'I. Gruev',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/bg.svg',
        shotsOnTarget: 1,
        shotsOffTarget: 4,
      },
      {
        name: 'G. Wilfried',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/it.svg',
        shotsOnTarget: 1,
        shotsOffTarget: 3,
      },
      {
        name: 'G. Gudmundsson',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/se.svg',
        shotsOnTarget: 1,
        shotsOffTarget: 7,
      },
      {
        name: 'D. James',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/wal.svg',
        shotsOnTarget: 1,
        shotsOffTarget: 2,
      },
    ],
    cards: [
      {
        name: 'E. Ampadu',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/wal.svg',
        yellowCards: 8,
        redCards: 0,
      },
      {
        name: 'J. Bogle',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        yellowCards: 6,
        redCards: 0,
      },
      {
        name: 'G. Gudmundsson',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/se.svg',
        yellowCards: 5,
        redCards: 0,
      },
      {
        name: 'P. Struijk',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/nl.svg',
        yellowCards: 4,
        redCards: 0,
      },
      {
        name: 'N. Okafor',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ch.svg',
        yellowCards: 3,
        redCards: 0,
      },
      {
        name: 'A. Stach',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/de.svg',
        yellowCards: 3,
        redCards: 0,
      },
      {
        name: 'J. Bijol',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/si.svg',
        yellowCards: 3,
        redCards: 0,
      },
      {
        name: 'J. Justin',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        yellowCards: 3,
        redCards: 0,
      },
      {
        name: 'I. Gruev',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/bg.svg',
        yellowCards: 3,
        redCards: 0,
      },
      {
        name: 'G. Wilfried',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/it.svg',
        yellowCards: 3,
        redCards: 0,
      },
      {
        name: 'S. Longstaff',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        yellowCards: 2,
        redCards: 0,
      },
      {
        name: 'L. Perri',
        position: 'goalkeeper',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/br.svg',
        yellowCards: 2,
        redCards: 0,
      },
      {
        name: 'D. Calvert-Lewin',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        yellowCards: 1,
        redCards: 0,
      },
      {
        name: 'B. Aaronson',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/us.svg',
        yellowCards: 1,
        redCards: 0,
      },
      {
        name: 'A. Tanaka',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/jp.svg',
        yellowCards: 1,
        redCards: 0,
      },
      {
        name: 'J. Rodon',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/wal.svg',
        yellowCards: 1,
        redCards: 0,
      },
      {
        name: 'S. Bornauw',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/be.svg',
        yellowCards: 1,
        redCards: 0,
      },
      {
        name: 'K. Darlow',
        position: 'goalkeeper',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/wal.svg',
        yellowCards: 1,
        redCards: 0,
      },
      {
        name: 'F. Buonanotte',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ar.svg',
        yellowCards: 1,
        redCards: 0,
      },
    ],
    injuries: [
      {
        name: 'D. James',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/wal.svg',
        status: 'missing',
      },
      {
        name: 'J. Rodon',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/wal.svg',
        status: 'missing',
      },
      {
        name: 'A. Stach',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/de.svg',
        status: 'missing',
      },
    ],
  },
  away: {
    goals: [
      {
        name: 'T. Arokodare',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ng.svg',
        goals: 3,
      },
      {
        name: 'R. Gomes',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/pt.svg',
        goals: 3,
      },
      {
        name: 'H. Hee-chan',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/kr.svg',
        goals: 2,
      },
      {
        name: 'L. Krejci',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/cz.svg',
        goals: 2,
      },
      {
        name: 'S. Bueno',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/uy.svg',
        goals: 2,
      },
      {
        name: 'M. Mane',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        goals: 2,
      },
      {
        name: 'A. Armstrong',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        goals: 1,
      },
      {
        name: 'J. Larsen',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/no.svg',
        goals: 1,
      },
      {
        name: 'M. Munetsi',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/zw.svg',
        goals: 1,
      },
      {
        name: 'H. Bueno',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/es.svg',
        goals: 1,
      },
      {
        name: 'J. Gomes',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/br.svg',
        goals: 1,
      },
      {
        name: 'J. Bellegarde',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ht.svg',
        goals: 1,
      },
      {
        name: 'J. Arias',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/co.svg',
        goals: 1,
      },
      {
        name: 'Andre',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/br.svg',
        goals: 1,
      },
    ],
    assists: [
      {
        name: 'A. Armstrong',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        assists: 2,
      },
      {
        name: 'D. Wolfe',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/no.svg',
        assists: 2,
      },
      {
        name: 'T. Arokodare',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ng.svg',
        assists: 1,
      },
      {
        name: 'H. Hee-chan',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/kr.svg',
        assists: 1,
      },
      {
        name: 'L. Krejci',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/cz.svg',
        assists: 1,
      },
      {
        name: 'S. Bueno',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/uy.svg',
        assists: 1,
      },
      {
        name: 'M. Mane',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        assists: 1,
      },
      {
        name: 'J. Larsen',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/no.svg',
        assists: 1,
      },
      {
        name: 'M. Munetsi',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/zw.svg',
        assists: 1,
      },
      {
        name: 'H. Bueno',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/es.svg',
        assists: 1,
      },
      {
        name: 'J. Gomes',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/br.svg',
        assists: 1,
      },
      {
        name: 'J. Bellegarde',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ht.svg',
        assists: 1,
      },
      {
        name: 'F. Lopez',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/es.svg',
        assists: 1,
      },
      {
        name: 'J. Tchatchoua',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/cm.svg',
        assists: 1,
      },
    ],
    shots: [
      {
        name: 'T. Arokodare',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ng.svg',
        shotsOnTarget: 10,
        shotsOffTarget: 14,
      },
      {
        name: 'M. Mane',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        shotsOnTarget: 9,
        shotsOffTarget: 12,
      },
      {
        name: 'J. Bellegarde',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ht.svg',
        shotsOnTarget: 7,
        shotsOffTarget: 6,
      },
      {
        name: 'L. Krejci',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/cz.svg',
        shotsOnTarget: 5,
        shotsOffTarget: 2,
      },
      {
        name: 'J. Larsen',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/no.svg',
        shotsOnTarget: 5,
        shotsOffTarget: 8,
      },
      {
        name: 'J. Gomes',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/br.svg',
        shotsOnTarget: 5,
        shotsOffTarget: 6,
      },
      {
        name: 'Y. Mosquera',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/co.svg',
        shotsOnTarget: 5,
        shotsOffTarget: 7,
      },
      {
        name: 'M. Munetsi',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/zw.svg',
        shotsOnTarget: 4,
        shotsOffTarget: 8,
      },
      {
        name: 'H. Bueno',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/es.svg',
        shotsOnTarget: 4,
        shotsOffTarget: 4,
      },
      {
        name: 'R. Gomes',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/pt.svg',
        shotsOnTarget: 3,
        shotsOffTarget: 6,
      },
      {
        name: 'H. Hee-chan',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/kr.svg',
        shotsOnTarget: 3,
        shotsOffTarget: 6,
      },
      {
        name: 'K. Hoever',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/nl.svg',
        shotsOnTarget: 3,
        shotsOffTarget: 0,
      },
      {
        name: 'S. Bueno',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/uy.svg',
        shotsOnTarget: 2,
        shotsOffTarget: 0,
      },
      {
        name: 'J. Arias',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/co.svg',
        shotsOnTarget: 2,
        shotsOffTarget: 6,
      },
      {
        name: 'E. Agbadou',
        position: 'defender',
        flag: null,
        shotsOnTarget: 2,
        shotsOffTarget: 1,
      },
      {
        name: 'A. Armstrong',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        shotsOnTarget: 1,
        shotsOffTarget: 3,
      },
      {
        name: 'J. Tchatchoua',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/cm.svg',
        shotsOnTarget: 1,
        shotsOffTarget: 0,
      },
      {
        name: 'T. Gomes',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/pt.svg',
        shotsOnTarget: 1,
        shotsOffTarget: 2,
      },
      {
        name: 'A. Gomes',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        shotsOnTarget: 1,
        shotsOffTarget: 4,
      },
      {
        name: 'Andre',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/br.svg',
        shotsOnTarget: 0,
        shotsOffTarget: 5,
      },
      {
        name: 'D. Wolfe',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/no.svg',
        shotsOnTarget: 0,
        shotsOffTarget: 1,
      },
      {
        name: 'F. Lopez',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/es.svg',
        shotsOnTarget: 0,
        shotsOffTarget: 1,
      },
      {
        name: 'M. Doherty',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ie.svg',
        shotsOnTarget: 0,
        shotsOffTarget: 1,
      },
      {
        name: 'T. Edozie',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        shotsOnTarget: 0,
        shotsOffTarget: 1,
      },
    ],
    cards: [
      {
        name: 'Y. Mosquera',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/co.svg',
        yellowCards: 11,
        redCards: 0,
      },
      {
        name: 'J. Gomes',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/br.svg',
        yellowCards: 9,
        redCards: 0,
      },
      {
        name: 'Andre',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/br.svg',
        yellowCards: 9,
        redCards: 0,
      },
      {
        name: 'J. Bellegarde',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ht.svg',
        yellowCards: 5,
        redCards: 0,
      },
      {
        name: 'L. Krejci',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/cz.svg',
        yellowCards: 4,
        redCards: 0,
      },
      {
        name: 'S. Bueno',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/uy.svg',
        yellowCards: 4,
        redCards: 0,
      },
      {
        name: 'M. Doherty',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ie.svg',
        yellowCards: 4,
        redCards: 0,
      },
      {
        name: 'H. Hee-chan',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/kr.svg',
        yellowCards: 3,
        redCards: 0,
      },
      {
        name: 'A. Armstrong',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        yellowCards: 3,
        redCards: 0,
      },
      {
        name: 'J. Tchatchoua',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/cm.svg',
        yellowCards: 3,
        redCards: 0,
      },
      {
        name: 'T. Gomes',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/pt.svg',
        yellowCards: 2,
        redCards: 1,
      },
      {
        name: 'J. Larsen',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/no.svg',
        yellowCards: 2,
        redCards: 0,
      },
      {
        name: 'M. Munetsi',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/zw.svg',
        yellowCards: 2,
        redCards: 0,
      },
      {
        name: 'E. Agbadou',
        position: 'defender',
        flag: null,
        yellowCards: 1,
        redCards: 1,
      },
      {
        name: 'J. Sa',
        position: 'goalkeeper',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/pt.svg',
        yellowCards: 2,
        redCards: 0,
      },
      {
        name: 'T. Arokodare',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ng.svg',
        yellowCards: 1,
        redCards: 0,
      },
      {
        name: 'H. Bueno',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/es.svg',
        yellowCards: 1,
        redCards: 0,
      },
      {
        name: 'J. Arias',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/co.svg',
        yellowCards: 1,
        redCards: 0,
      },
      {
        name: 'D. Wolfe',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/no.svg',
        yellowCards: 1,
        redCards: 0,
      },
      {
        name: 'F. Lopez',
        position: 'forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/es.svg',
        yellowCards: 1,
        redCards: 0,
      },
      {
        name: 'A. Gomes',
        position: 'midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        yellowCards: 1,
        redCards: 0,
      },
    ],
    injuries: [
      {
        name: 'S. Johnstone',
        position: 'goalkeeper',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        status: 'missing',
      },
      {
        name: 'M. Doherty',
        position: 'defender',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ie.svg',
        status: 'doubtful',
      },
      {
        name: 'E. Gonzalez',
        position: null,
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        status: 'missing',
      },
    ],
  },
};
